export const navLinks = [
  { id: 'about', label: '影片概览' },
  { id: 'versions', label: '版本对比' },
  { id: 'online', label: '在线播放' },
  { id: 'download', label: '迅雷下载' },
  { id: 'tips', label: '画质字幕' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '5', label: '常见版本类型', icon: 'ri-stack-line' },
  { value: '2', label: '观看途径方向', icon: 'ri-road-map-line' },
  { value: '12', label: '查找与排错要点', icon: 'ri-list-check-2' },
  { value: '100%', label: '版权合规提示', icon: 'ri-shield-check-line' },
];

export const quickCards = [
  {
    icon: 'ri-movie-2-line',
    title: '认准版本再动手',
    desc: '未删减、高清修复、国语中字这几类版本在片长、画面与配音上都不一样，先明确需求能少走很多弯路。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '关键词组合更高效',
    desc: '把片名与版本词、语言词组合搜索，比只搜单一关键词更容易命中你真正想要的那一版。',
  },
  {
    icon: 'ri-download-2-line',
    title: '下载先看资源信息',
    desc: '种子与磁力会写明分辨率、码率、字幕与语言，先读说明再决定是否下载，避免下到不匹配的资源。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '注意合规与安全',
    desc: '优先选择正规授权平台；来源不明的下载链接存在风险，安装与点击前请多留个心眼。',
  },
];

export const aboutParagraphs = [
  '蜜桃成熟时3D 属于早年港产片在大银幕与网络流传过程中被反复讨论的一类作品。随着时间推移，网络上出现了多种来源、多种清晰度、甚至不同删改程度的片源，观众在搜索时往往会被“完整版”“未删减”“高清修复”等名词绕晕，不知道该从哪一版看起。',
  '本站并不提供任何影片的正片文件，而是把围绕该片的版本信息、检索思路与观看建议整理成一页可对照的指南。你可以把它理解成一份“看片前的地图”：先搞清楚有哪些版本、它们彼此差在哪、在线与下载各有什么查找思路，再根据自己的设备和语言习惯做选择。',
  '由于不同平台、不同年份流传的片源差异较大，本页涉及的具体数值（如片长、分辨率）仅用于说明版本之间“可能存在的差别”，并不代表某一版的权威参数。实际以你在正规渠道看到的官方信息为准。',
];

export const versionTabs = [
  { id: 'uncut', label: '按删改程度' },
  { id: 'quality', label: '按画质' },
  { id: 'language', label: '按语言字幕' },
];

export const versions = [
  {
    tag: 'uncut',
    name: '未删减完整版',
    badge: '情节最全',
    duration: '片长相对最长',
    desc: '保留了较完整的情节与镜头，适合希望从头到尾完整体验故事线的观众。网络上标注“未删减”的片源，需要核对片长与关键情节是否连贯。',
    best: '想完整看剧情、不接受跳剪的观众',
  },
  {
    tag: 'uncut',
    name: '删减/公映版',
    badge: '时长较短',
    duration: '片长相对更短',
    desc: '在不同发行或播放渠道中可能存在被删改的版本，部分镜头会被替换或省略。观看时若发现情节跳跃，多半是遇到了删减版。',
    best: '只想快速了解主线剧情的观众',
  },
  {
    tag: 'quality',
    name: '高清修复版',
    badge: '画面清晰',
    duration: '分辨率更高',
    desc: '通过去噪、调色与分辨率提升等手段，把早年片源处理得更清晰。画质观感更好，但个别修复版也可能因处理方式不同而改变原片色调。',
    best: '重视画面观感、大屏观看的观众',
  },
  {
    tag: 'quality',
    name: '标清/普通片源',
    badge: '体积更小',
    duration: '分辨率较低',
    desc: '文件体积小、加载快，适合网络条件一般或只用手机临时观看的场景，但在大屏上细节会明显偏糊。',
    best: '网络受限、临时观看的观众',
  },
  {
    tag: 'language',
    name: '国语中字版',
    badge: '普通话配音',
    duration: '配音为主',
    desc: '以普通话配音搭配中文字幕呈现，方便不习惯粤语的观众。需要注意配音版与原始版本在语气、台词处理上可能存在差异。',
    best: '普通话观众、更看重听感',
  },
  {
    tag: 'language',
    name: '粤语原声中字版',
    badge: '原声呈现',
    duration: '原声为主',
    desc: '保留粤语原声搭配中文字幕，更接近作品原本的语言质感，适合想体会原汁原味的观众。',
    best: '喜欢原声、追求原貌的观众',
  },
];

export const onlineSteps = [
  {
    no: '01',
    title: '先确定想要的版本',
    desc: '想清楚你要的是未删减、高清修复还是国语中字，把版本词先记下来，后续搜索会更聚焦。',
  },
  {
    no: '02',
    title: '在正规平台搜索片名',
    desc: '先到有正规授权的视频平台，用影片全名搜索。能上架的通常是版权清晰的版本，画质与服务也更有保障。',
  },
  {
    no: '03',
    title: '用版本关键词组合检索',
    desc: '若正规平台没有，再用“片名 + 未删减 / 高清修复 / 国语中字”等组合词检索，逐一核对搜索结果描述是否匹配。',
  },
  {
    no: '04',
    title: '核对片长与画面',
    desc: '打开播放页后，先看总片长、开头的片头与清晰度标注，与你想要的版本特征比对，再决定是否继续观看。',
  },
  {
    no: '05',
    title: '留意页面安全与版权',
    desc: '对要求安装陌生插件、反复弹窗或索取账号密码的站点保持警惕；能选择正规渠道时优先选择正规渠道。',
  },
];

export const downloadMethods = [
  {
    icon: 'ri-links-line',
    name: '磁力链接',
    label: '最常见',
    desc: '磁力链接本身只是一串标识，不直接存放文件，需要配合下载工具获取资源。文件信息通常写在资源标题里，可据此判断分辨率、语言与字幕。',
    points: ['先看标题是否含所需版本词', '核对文件大小与分辨率是否匹配', '注意做种人数，太少可能下不动'],
  },
  {
    icon: 'ri-file-cloud-line',
    name: 'BT 种子文件',
    label: '信息完整',
    desc: '种子文件里包含文件名列表与大小信息，比纯磁力更容易提前看清资源构成，适合想先确认内容再下载的观众。',
    points: ['下载后用工具打开预览文件列表', '确认是否附带字幕文件', '避免下载来路不明的可执行文件'],
  },
  {
    icon: 'ri-folder-download-line',
    name: '网盘转存',
    label: '较便捷',
    desc: '部分资源以网盘分享的形式存在，转存到自己网盘后再下载。这种方式依赖分享链接的有效性，也更容易遇到失效或需付费提速的情况。',
    points: ['注意链接是否有提取码', '警惕要求注册陌生站点', '分享失效属常见现象'],
  },
  {
    icon: 'ri-cloud-line',
    name: '在线云播 / 直链',
    label: '免下载',
    desc: '部分站点提供在线播放或直链播放，无需本地下载即可观看，但画质、稳定性与来源可靠性参差不齐，需自行判断。',
    points: ['优先选择有正规牌照的平台', '注意播放页的跳转与弹窗', '清晰度标注需实际播放确认'],
  },
];

export const downloadWarnings = [
  '只从你能大致判断来源的渠道获取资源，来源不明的文件不要随意运行。',
  '下载工具的正规版本即可，遇到要求额外安装“解码包”“播放插件”的要谨慎。',
  '涉及付费提速、代下载、代充会员等，多为诱导消费，请理性对待。',
  '若作品已在正规平台上线，优先支持正版，这也是最稳定、最安全的观看方式。',
];

export const techTips = [
  {
    icon: 'ri-hd-line',
    title: '分辨率与码率怎么看',
    points: [
      '1080P 指纵向像素数，但同样的 1080P，码率越高通常画面越干净。',
      '老片修复版不必一味追求极高分辨率，去噪是否过度更影响观感。',
      '手机竖屏观看时，过高分辨率带来的提升有限，反而更吃流量。',
    ],
  },
  {
    icon: 'ri-translate-2',
    title: '字幕与配音的取舍',
    points: [
      '国语配音版听着省力，但语气和台词可能与原版有差异。',
      '粤语原声配中文字幕更接近原貌，适合追求原汁原味。',
      '外挂字幕要注意时间轴是否对齐，字幕编码错误会出现乱码。',
    ],
  },
  {
    icon: 'ri-device-line',
    title: '播放设备建议',
    points: [
      '大屏电视或显示器更适合欣赏高清修复版，细节更明显。',
      '手机观看建议横屏，并把亮度调到舒适区间，减少疲劳。',
      '外接音箱或耳机能明显改善听感，尤其是原声版本。',
    ],
  },
  {
    icon: 'ri-play-circle-line',
    title: '播放器与兼容性',
    points: [
      '多数格式用常见播放器即可播放，遇到打不开先看是否缺解码。',
      '画面卡顿多与码率、设备性能或网络有关，可先降低清晰度。',
      '播放异常时，换一个片源或换个时段重试往往更有效。',
    ],
  },
];

export const faqs = [
  {
    q: '蜜桃成熟时3D 的“完整版”和“未删减”是一回事吗？',
    a: '两者经常被混用，但并不完全等同。“完整版”通常强调内容齐全，而“未删减”更强调没有经过删改。实际判断时，最可靠的方法是核对片长以及关键情节是否连贯，而不是只看标题里的字样。',
  },
  {
    q: '为什么同一个片名会搜到好几种不同片长的结果？',
    a: '因为不同发行、不同平台、不同年份流传的片源本身就可能存在差异，删改、剪辑或版本更新的情况都会让片长变化。遇到这类情况，建议先明确自己想要哪一版，再逐一核对。',
  },
  {
    q: '高清修复版一定比普通版好看吗？',
    a: '不一定。修复能提升清晰度与画面干净程度，但如果处理过度，也可能让画面失去原有的胶片质感或改变色调。是否更好看，取决于修复的具体做法以及个人偏好。',
  },
  {
    q: '国语中字版和粤语原声版该怎么选？',
    a: '看你更在意听感还是原貌。国语配音版听着更省力，适合普通话观众；粤语原声配中文字幕更接近作品原本的语言气质。两者没有绝对优劣，按习惯选择即可。',
  },
  {
    q: '用迅雷等工具下载时要注意什么？',
    a: '先看资源标题里写明的信息，确认版本、分辨率与字幕；注意做种情况，太冷门的资源可能下不动；对来源不明的文件和额外安装要求保持警惕。若作品有正规渠道，优先选择正规渠道更稳妥。',
  },
  {
    q: '在线看和下载看有什么实际区别？',
    a: '在线看免下载、随点随看，但清晰度与稳定性受网络和站点影响；下载看可以在本地保存、反复观看，画质更可控，但需要占用存储空间并等待下载完成。按使用场景选择就好。',
  },
];